/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

const Disclaimers = () => {
  return (
    <div className="pt-1 pb-3 container-fluid">
      <h1 className="fs-4 pb-3">Disclaimers</h1>
      <p>
        saferetirementspending.com (“SRS”) is for entertainment purposes only. It cannot be
        considered advice or guidance for investment decisions or, for that matter, any other
        decisions. If uncertain, always consult an investment advisor and/or accountant.
      </p>
      <p>
        SRS makes no representations of the accuracy, completeness, currentness, suitability, or
        validity of any information on this site. It will not be liable for any errors, omissions,
        or delays in this information or any losses, injuries, or damages arising from its display
        or use. Furthermore, SRS assumes no responsibility for the accuracy, completeness,
        currentness, suitability, and validity of any and all external links you find here.
      </p>
    </div>
  )
}

export default Disclaimers
